import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" untuk STT ")
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "inline-flex mt-6 justify-center" }
const _hoisted_5 = { class: "inline-flex justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-center mt-2"
}
const _hoisted_7 = { class: "text-gray-lp-300 font-medium text-12px mt-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Waktu pembayaran tersisa : ")
const _hoisted_9 = { class: "ml-2 bg-pink-lp-200 p-1 text-red-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogPaymentLayoutHeader = _resolveComponent("DialogPaymentLayoutHeader")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DialogPaymentLayoutHeader, {
      billType: _ctx.billType,
      textHeader: _ctx.billAmountAfterDiscount,
      textSubHeader: _ctx.billAmount
    }, {
      "sub-header": _withCtx(() => [
        (_ctx.billType === 'booking')
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _hoisted_2,
              _createVNode("span", _hoisted_3, _toDisplayString(_ctx.sttNumber), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["billType", "textHeader", "textSubHeader"]),
    _createVNode("div", _hoisted_4, [
      _createVNode("img", {
        alt: "payment-logo",
        class: "h-6",
        src: 
        require(`@/app/ui/assets/svg/payment/${_ctx.paymentMethod.logo}-active.svg`)
      
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("img", {
        src: _ctx.qrImageBase64,
        alt: "qr-code"
      }, null, 8, ["src"])
    ]),
    (_ctx.timeoutDuration > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.qrTimer), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}